import axios from "axios";
import * as services from "redux/services";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      services.removeLoginUser();
      window.location.href = "/auth/login";
    }
    return Promise.reject(error);
  }
);

export const headers = {
  Accept: "application/json",
};

export const contentHeader = {
  "Content-Type": "application/json",
};

export const clientRequest = (method, url, data, customHeader) => {
  const token = `Bearer ${services.getToken()}`;
  return axios({
    headers: { ...headers, ...customHeader, Authorization: token },
    method,
    url,
    data,
  });
};

export const clientImageRequest = async (method, url, data, customHeader, responseType) => {
  const token = `Bearer ${services.getToken()}`;
  return axios({
    headers: { ...headers, ...customHeader, Authorization: token },
    method,
    url,
    data,
    responseType,
  });
};